import React from 'react';
import {useTranslation} from 'react-i18next';
import {TextInput} from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import {useRecoilState} from "recoil";
import {activeAutom} from "../../../../recoil-store/recoil-state";
import AppCredential from "../AppCredential/AppCredential";

function ListScope({action, variables, setOpenVariable, automId, showAlert, automVersionId}) {
    const {t} = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WHATSAPP.LIST-SCOPE.';
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);

    const updateLabel = (id, items) => {
        items.forEach(item => {
            if (item.id === id) {
                item.fields = action.fields;
            } else if (item.children) {
                updateLabel(id, item.children);
            }
        });
    };

    const handleBlur = () => {
        let fields = action.fields;
        let items = JSON.parse(JSON.stringify(automDetail.items));
        action.fields = JSON.parse(JSON.stringify(fields));
        updateLabel(action.id, items);
        setAutomDetail({...automDetail, items: JSON.parse(JSON.stringify(items))});
    };

    return (
        <div>
            <AppCredential action={action}/>
            <div className="form-element">
                {t(label + "LABEL")}
                <TextInput
                    action={action}
                    inputName="label"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    onBlur={handleBlur}
                />
            </div>
            <div className="form-element">
                {t(label + 'HEADER-INPUT')}
                <TextInput action={action} inputName="header" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'HEADER-INPUT')}/>
            </div>
            <div className="form-element">
                {t(label + 'BODY')}
                <TextInput action={action} inputName="body" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired={true}  fieldType="string" displayName={t(label + 'BODY')}/>
            </div>
            <div className="form-element">
                {t(label + 'FOOTER')}
                <TextInput action={action} inputName="footer" variables={variables} setOpenVariable={setOpenVariable}  fieldType="string" displayName={t(label + 'FOOTER')}/>
            </div>
            <div className="form-element">
                {t(label + 'BUTTON-TEXT')}
                <TextInput action={action} inputName="button" variables={variables} setOpenVariable={setOpenVariable}
                           isRequired={true}  fieldType="string" displayName={t(label + 'BUTTON-TEXT')}/>
            </div>
        </div>
    );
}

export default ListScope;
